import * as React from 'react';
import {Breadcrumb, Grid, Button, Input} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    FilterObjectComponentProps,
    InfinityScrollComponentProps, ViewSettingsComponentProps, withFilterObject,
    withInfinityScrollHandlers, withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../lib/RestClient';
import Moment from 'react-moment';
import MailBoxManagementEditModal from "./MailBoxManagementEditModal";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'filename',
        labelTranslationKey: 'MailBoxManagement.Filename',
        required: true
    },
    {
        fieldName: 'data.userId',
        labelTranslationKey: 'MailBoxManagement.UserId',
        required: true
    },
    {
        fieldName: 'updatedAt',
        labelTranslationKey: 'MailBoxManagement.UpdatedAt',
        required: true,
        cellRender: v => <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>
    },
    {
        fieldName: 'updatedBy',
        labelTranslationKey: 'MailBoxManagement.UpdatedBy',
        required: true
    },
    {
        fieldName: '',
        labelTranslationKey: 'MailBoxManagement.Actions',
        required: true,
        cellRender: (_, row) => {

            let ob = JSON.parse(JSON.stringify(row));
            ob["__column"] = undefined;

            return(<>
                <Button icon={"edit"} onClick={()=>refresh(true, ob)} />
            </>);
        }
    }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

let refresh: Function = ()=>{};

function handleRefresh(refreshFunction: Function) {
    refresh = refreshFunction;
}

const PageComponent = (props: InfinityScrollComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps & RouteComponentProps<any>) => {

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }
    return (
        <>
            <AnalyticsTracking page="mailbox_management" />
            <div className={"sticky-header"}>
                <div className={"ui container"}>
                    <h3><Breadcrumb icon="right angle" sections={[
                        {
                            key: '1',
                            as: NavLink,
                            to: '/mailboxManagement',
                            content: `${t("Route.MailBoxManagement")}`, link: true
                        }
                    ]}/></h3>
                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>

                    <Grid columns={4} className={"HeadingGrid"} stackable={true}
                          style={{marginBottom: '1em'}}>
                        <Grid.Column width={4}>
                            <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                                   value={props.filterObject.filter}
                                   onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
                        </Grid.Column>
                        <Grid.Column width={4}>
                        </Grid.Column>
                        <Grid.Column width={4}>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <MailBoxManagementEditModal handleRefresh={handleRefresh} />
                        </Grid.Column>
                    </Grid>

                </div>
            </div>
            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    loading={props.loading}
                    filter={props.filterObject}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
        return RestClient.get('mailboxManagement', {
            sort: 'createdAt,desc',
            page: page,
            count: 50,
            filter: filter.filter
        });
    }
};

const PageComponentWrapped = withRouter(withFilterObject(withViewSettings(withInfinityScrollHandlers(PageComponent))));

export default () => (
    <PageComponentWrapped
        viewName="MailBoxManagement"
        defaultFilter={{"filter": ""}}
        dataService={dataService}
    />
);
